import styled from "styled-components";

export const RateCard = styled.div`
  border: 1px solid black;
  padding: 10px;
  width: 100% !important;
`;
